// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uploadBox__XWVag {
  display: flex;
  align-items: center;

  width: 288px;
  height: 33px;
  margin-top: 20px;
  padding: 6px 16px;

  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.015em;

  background: rgb(255 255 255 / 60%);
  border-radius: 6px;
}

.uploadBox__XWVag label {
  cursor: pointer;
  display: flex;
  gap: 7px;
}

.fileItem__t376b {
  display: flex;
  align-items: center;

  width: 288px;
  height: 20px;
  margin-top: 8px;
  padding: 8px 16px;

  font-size: 14px;

  background: rgb(255 255 255 / 70%);
  border-radius: 6px;
}

.fileName__AZi0Q {
  overflow: hidden;
  display: inline-block;
  flex-grow: 1;

  text-overflow: ellipsis;
  white-space: nowrap;
}

.removeButton__ldWiX {
  cursor: pointer;

  display: flex;
  align-items: center;

  margin-left: 8px;
  padding: 0;

  background: none;
  border: none;
}

.removeButton__ldWiX:focus {
  outline: none;
}

.sizeExceeded__AWzkB {
  border: 1px solid #f03636;
}

.sizeExceededText__B0beN {
  margin-top: 4px;
  font-size: 13px;
  color: #f03636;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/WriteToUsForm/FileUpload/FileUpload.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;;EAEnB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;;EAEjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;;EAEvB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;;EAEnB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,iBAAiB;;EAEjB,eAAe;;EAEf,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;;EAEZ,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;;EAEf,aAAa;EACb,mBAAmB;;EAEnB,gBAAgB;EAChB,UAAU;;EAEV,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".uploadBox {\n  display: flex;\n  align-items: center;\n\n  width: 288px;\n  height: 33px;\n  margin-top: 20px;\n  padding: 6px 16px;\n\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  letter-spacing: 0.015em;\n\n  background: rgb(255 255 255 / 60%);\n  border-radius: 6px;\n}\n\n.uploadBox label {\n  cursor: pointer;\n  display: flex;\n  gap: 7px;\n}\n\n.fileItem {\n  display: flex;\n  align-items: center;\n\n  width: 288px;\n  height: 20px;\n  margin-top: 8px;\n  padding: 8px 16px;\n\n  font-size: 14px;\n\n  background: rgb(255 255 255 / 70%);\n  border-radius: 6px;\n}\n\n.fileName {\n  overflow: hidden;\n  display: inline-block;\n  flex-grow: 1;\n\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.removeButton {\n  cursor: pointer;\n\n  display: flex;\n  align-items: center;\n\n  margin-left: 8px;\n  padding: 0;\n\n  background: none;\n  border: none;\n}\n\n.removeButton:focus {\n  outline: none;\n}\n\n.sizeExceeded {\n  border: 1px solid #f03636;\n}\n\n.sizeExceededText {\n  margin-top: 4px;\n  font-size: 13px;\n  color: #f03636;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export var uploadBox = `uploadBox__XWVag`;
export var fileItem = `fileItem__t376b`;
export var fileName = `fileName__AZi0Q`;
export var removeButton = `removeButton__ldWiX`;
export var sizeExceeded = `sizeExceeded__AWzkB`;
export var sizeExceededText = `sizeExceededText__B0beN`;
export default ___CSS_LOADER_EXPORT___;
